<script lang="ts">
  export let size = 20;
</script>

<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.1341 9.05817C10.0508 9.04984 9.95078 9.04984 9.85911 9.05817C7.87578 8.9915 6.30078 7.3665 6.30078 5.3665C6.30078 3.32484 7.95078 1.6665 10.0008 1.6665C12.0424 1.6665 13.7008 3.32484 13.7008 5.3665C13.6924 7.3665 12.1174 8.9915 10.1341 9.05817Z"
    class={$$props.class || "stroke-current"}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M5.96758 12.1335C3.95091 13.4835 3.95091 15.6835 5.96758 17.0252C8.25924 18.5585 12.0176 18.5585 14.3092 17.0252C16.3259 15.6752 16.3259 13.4752 14.3092 12.1335C12.0259 10.6085 8.26758 10.6085 5.96758 12.1335Z"
    class={$$props.class || "stroke-current"}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
